import React from "react";
import { Loading } from "./style";

const Index = ({ hasDisabled, right = false, color = false }: any) => {
  return (
    <Loading right={right} color={color} hasDisabled={hasDisabled}>
      <div className="w-100 h-100 d-flex align-items-center justify-content-center">
        <div className="lds-dual-ring"></div>
      </div>
    </Loading>
  );
};

export default Index;
